import { Instagram } from "lucide-react";
import { CONTACT } from "@/data/site";

const TikTok = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16.6 2h-3.3v13.4a2.9 2.9 0 1 1-2.9-2.9c.3 0 .6 0 .9.1V9.2a6.3 6.3 0 1 0 5.3 6.2V8.6a7.9 7.9 0 0 0 4.6 1.5V6.8a4.6 4.6 0 0 1-4.6-4.6z" />
  </svg>
);

const LINKS = [
  { id: "instagram", label: "Instagram", handle: "@ka.gartenservice", href: CONTACT.instagram, icon: Instagram },
  { id: "tiktok", label: "TikTok", handle: "@khaled_19277", href: CONTACT.tiktok, icon: TikTok },
];

export const SocialLinks = ({ dark = false }) => (
  <div className="flex flex-wrap gap-2">
    {LINKS.filter((l) => l.href).map((l) => (
      <a key={l.id} href={l.href} target="_blank" rel="noreferrer" aria-label={`${l.label} ${l.handle}`} data-testid={`social-${l.id}${dark ? "-dark" : ""}`}
        className={`group inline-flex items-center gap-2 rounded-full border px-4 py-2.5 text-sm font-medium transition-colors duration-300 ${dark ? "border-white/15 text-white hover:bg-white hover:text-[#111511]" : "border-[#111511]/10 bg-white text-[#111511] hover:bg-[#111511] hover:text-white"}`}>
        <l.icon className="w-4 h-4" /> {l.label}
      </a>
    ))}
  </div>
);
